<template>
    <a :href="assetUrl" :download="assetFileName" @click.prevent="downloadAsset" v-html="text" />
</template>

<script>
import { downloadAssetCTF } from '../../../plugins/contentful'
export default {
  name: 'CtfRichTextAssetLink',
  props: {
    sysId: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      assetUrl: '#',
      assetFileName: ''
    }
  },
  async created () {
    const asset = await downloadAssetCTF(this.sysId)
    if (asset) {
      this.assetUrl = asset.fields.file.url
      this.assetFileName = asset.fields.title
    }
  },
  methods: {
    async downloadAsset () {
      if (!this.assetUrl || this.assetUrl === '#') return
      fetch(this.assetUrl, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'cors'
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = ''

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            blobUrl = window.navigator.msSaveOrOpenBlob(blob, this.assetFileName)
          } else {
            blobUrl = window.URL.createObjectURL(blob)
          }

          const a = document.createElement('a')
          a.download = this.assetFileName
          a.href = blobUrl
          // For Firefox https://stackoverflow.com/a/32226068
          document.body.appendChild(a)
          a.click()
          a.remove()
        })
        .catch(() =>
          window.open(this.assetUrl, 'Download')
        )
    }
  }
}
</script>
